import React from "react";
import img from "../../../assets/images/profile.png";
import "../Header/Header.css";
import { Typewriter } from "react-simple-typewriter";

const Header = () => {
  return (
    <div className="hero" style={{ minHeight: "calc(100vh - 6.5rem)" }}>
      <div className="hero-content max-w-[1800px] mx-auto grid lg:grid-cols-2  ">
        <div
          className="pl-0 mx-w-1/2 "
          data-aos="fade-right"
          data-aos-duration="1500"
        >
          <img
            src={img}
            className=" rounded-lg shadow-2xl image mr-40 rounded-full ring ring-pink-600 ring-offset-base-100 ring-offset-2 "
            alt=""
          />
        </div>
        <div className=" text-left w-full " data-aos="fade-left">
          <h1 className="text-6xl font-bold">
            <span className="text-black-600">Hi there, I am</span> <br /> Md
            Shariful Islam
          </h1>
          <h1 className="text-3xl font-bold mt-9 text-pink-600">
            SOFTWARE DEVELOPER
          </h1>
          <div>
            <div className="mt-5">
              {/* <span>
                {"  "}
                <h1 className="inline-block text-2xl font-bold">EXPERT IN </h1>
              </span>
              <span>{` `}</span> */}
              <h3 className="inline-block text-pink-600 text-2xl font-bold">
                <span>
                  {/* Style will be inherited from the parent element */}
                  <Typewriter
                    words={[
                      "I LOVE CODING",
                      "I DEVELOP MOBILE APPS",
                      "I CODE COOL WEBSITE WITH REACT",
                    ]}
                    loop={0}
                    cursor
                    cursorStyle="|"
                    typeSpeed={70}
                    deleteSpeed={50}
                    delaySpeed={1000}
                  />
                </span>
              </h3>
            </div>
          </div>
          <p className="py-6">
            2 years experienced in Frontend development with a given history of
            working in the following company. Computer Science graduate and
            competent software developer highly skilled in dynamic frontend
            content. I am enthusiastic about advancing my career in this domain
            by joining an interactive and vibrant team where I could contribute
            my professional knowledge and efficient collaboration at a project
            level. I am quick learner and I strive for excellence as I always
            prefer quality over quantity.
          </p>
          <button className=" bg-pink-600 p-3 rounded text-xl font-semibold">
            <a
              href="https://drive.google.com/file/d/1l4a48uRb_ymAprCmHNKbg1Kdx6WDl61f/view?usp=share_link"
              target="_blank"
              rel="noopener noreferrer"
            >
              DOWNLOAD RESUME
            </a>
          </button>
        </div>
      </div>
    </div>
  );
};

export default Header;
